// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productTextBadgesStyles } from "@insite/content-library/Components/ProductTextBadges";
import { css } from "styled-components";

productTextBadgesStyles.container = {
    ...productTextBadgesStyles.container,
    css: css`
        display: flex;
        gap: 8px;
    `,
};

productTextBadgesStyles.badgeText = {
    weight: fontConfig.weight.bold,
    size: 10,
    css: css`
        padding: 0;
        width: auto;
        margin: auto;
        line-height: 16px;
        ${wrapInContainerStyles}
    `,
};

productTextBadgesStyles.badge = {
    css: css`
        margin-top: 0;
        height: 24px;
        width: fit-content;
    `,
};
